import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const repairOrderTireSidesAdapter = getAdapter({ idFieldName: 'value' });

const repairOrderTireSidesSlice = createSlice({
  name: 'repairOrderTireSides',
  initialState: repairOrderTireSidesAdapter.getInitialState(),
  reducers: {
    setRepairOrderTireSides: (state, { payload: { repairOrderTireSides } }) => {
      repairOrderTireSidesAdapter.setAll(state, repairOrderTireSides);
    },
  },
});

const selectors = repairOrderTireSidesAdapter.getSelectors(
  ({ repairOrderTireSides }) => repairOrderTireSides,
);

export const getRepairOrderTireSides = (state) => selectors.selectAll(state);

export const { setRepairOrderTireSides } = repairOrderTireSidesSlice.actions;

export default repairOrderTireSidesSlice.reducer;
